<template>
  <div id="main-layout" class="alpha-container">
    <div v-if="displayHead" class="ml-header">
      <div class="credit-display" style="min-width: 85px; justify-content: flex-end; margin-right: 1em;">
        <span>{{r}}</span><img src="@/assets/credits.png"/>
      </div>
      <a href="https://discord.gg/BCCb6YG" class="cobblebox" target="_blank" style="min-width: 60px; justify-content: center; background: #7289da;">
        Discord server
      </a>
    </div>
    <div id="ml-contain">
      <slot />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ProfileCard from "../components/Home/ProfileCard.vue";
export default {
  props: {
    user: Object,
    children: Array,
    displayHead: Boolean
  },
  components: { ProfileCard },
  mounted() {},
  computed: {
    unreadNotifications() {
      return Object.values(this.user.notifications).filter(n => !n.read).length;
    },
    r() {
      return Math.floor(Math.random() * 122);
    }
  }
};
</script>

<style scoped>
#main-layout {
  margin: 0 auto;
  width: 90%;
  max-width: 940px;
  overflow: hidden;
  position: relative;
}
.alpha-container {
  height: 523px;
  max-width: 940px;
  color: white;
  margin: 15px 0;
  border-radius: 22px;
  border: 12px solid rgba(255,255,255,0.3);
  box-shadow: inset 0 1px 33px 0 #4F4F4F;
}
#ml-contain {
  border-radius: 12px;
  overflow: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border: 5px solid rgba(0,0,0,0.08);
  z-index: 3;
}
.ml-header {
  max-width: 800px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 5;
  margin: 1.3em 1em;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-end;
}
.ml-header > * {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-width: 4px;
  text-align: center;
  color: white;
}

.alpha-container .content-body {
  background: rgba(255, 255, 255, 0.8);
  padding: 20px;
  margin: 20px 30px 20px 20px;
  border-radius: 8px;
  color: #444;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
  position: relative;
}
.alpha-container .media + .media {
  margin-top: 5px;
  padding-top: 5px;
}
.alpha-container .sidebar a.important-link {
  color: green;
}
#navigation {
  margin: 10px 0;
}
#navigation::-webkit-scrollbar {
  display: none;
}
#navigation li a {
  display: block;
  /* background: rgba(255, 255, 255, 0.2); */
  color: rgb(1, 76, 119);
  padding: 3px 7px;
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
  transition: all 0.15s ease-in-out;
  border-radius: 4px 0 0 4px;
}
#navigation li.dividing-nav {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 5px;
  margin-top: 5px;
}
#navigation li a:hover {
  background: rgba(255, 255, 255, 0.3);
  color: rgb(14, 114, 172);
}
#navigation li a.router-link-active {
  background: rgba(255, 255, 255, 0.6);
  color: rgb(26, 134, 197);
  font-weight: bold;
}
#navigation li a.router-link-active span {
  font-weight: normal;
}

@media screen and (max-width: 753px) {
  #navigation {
    margin-top: 0;
  }
  #navigation a {
    color: #c1cdc9 !important;
  }
  #navigation a.router-link-active {
    color: #bda753 !important;
  }
  .alpha-container .sidebar {
    width: 100%;
    padding: 15px 20px;
  }
  #navigation {
    padding: 12px;
    width: 100%;
    display: inline-flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border-radius: 8px;
    background: #256674;
  }
  .logo {
    display: inline;
    margin: auto 1rem 0 auto;
  }
  .sidebar .media {
    display: inline-flex;
  }

  #navigation li {
    flex: 0 0 auto;
  }
  #navigation li a {
    display: inline;
    border-radius: 4px;
    font-size: smaller;
    border: 1px solid rgba(255, 255, 255, 0.1);
    margin-right: 5px;
  }
  #navigation li a.router-link-active {
    border: 1px solid rgba(255, 255, 255, 1);
    color: white !important;
  }
  #navigation li.dividing-nav {
    padding: 0;
    margin: 0;
    border: 0;
    display: inline;
  }
}
</style>
